<template>
  <v-card rounded="xl" :color="last ? 'primary' : 'grey lighten-4'">
    <payment-user-info
      :item="item"
      :settings="settings"
      color="grey lighten-4"
      text-color="grey--text text--darken-3"
      icon-color="#444"
    ></payment-user-info>
    <div class="px-4" style="padding: 64px 0px">
      <p
        class="text-center text-uppercase display-1 mb-10"
        :class="last ? 'white--text' : 'grey--text text--darken-3'"
      >
        <u>{{ $t("you_didnt_order_on_time") }}</u>
      </p>
      <p
        :class="last ? 'white--text' : 'grey--text text--darken-3'"
        :style="{ fontSize: foodFontSize }"
        class="text-center font-weight-bold text-uppercase mb-10"
      >
        {{ $t("pick_up") }} {{ mealName }}
      </p>
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-img
            v-if="mealImage"
            :src="mealImage"
            width="100%"
            class="rounded-lg"
            :aspect-ratio="1"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import conf from "@/config";
import moment from "moment";
import PaymentUserInfo from "@/components/canteen/cards/components/PaymentUserInfo.vue";
import PaymentOrderMealCard from "@/components/canteen/cards/components/PaymentOrderMealCard.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
    },
    last: {
      type: Boolean,
    },
  },
  components: {
    PaymentUserInfo,
    PaymentOrderMealCard,
  },
  data() {
    return {
      conf,
      moment,
    };
  },
  computed: {
    foodFontSize() {
      return this.settings?.font?.size?.food * 1.3 + "px";
    },
    mealName() {
      return (
        this.toLatin(this.item.order.transaction[0]?.food?.name) ||
        this.$t("replacement_meal")
      );
    },
    mealImage() {
      const imageName = this.item.order.transaction[0]?.food?.image?.name;
      if (!imageName) {
        const bg = this.last ? "white" : "grey";
        return `./media/img/replacement_meal_${bg}.png`;
      }
      return `${conf.apiUrlBase}/gallery/${this.$store.state.company.restaurant.id}/medium/${imageName}`;
    },
    lighten() {
      return !this.item.user.message.success || this.last;
    },
    cardBackground() {
      // Responsive background if needed, else fallback to original logic
      return !this.item.user.message.success
        ? "background: linear-gradient(0deg, rgba(213, 19, 21, 1) 0%, rgba(239, 7, 10, 1) 100%)"
        : this.last
        ? "background: linear-gradient(0deg, rgba(247, 150, 89, 1) 0%, rgba(253, 191, 127, 1) 100%)"
        : "background: linear-gradient(0deg, rgba(248, 249, 248, 1) 0%, rgba(234, 234, 234, 1) 100%)";
    },
  },
};
</script>

<style scoped>
.poppins-medium {
  font-family: Tahoma, sans-serif;
  font-weight: 500;
  font-style: normal;
}

.payment-order-card {
  background: #ffbd7e;
  background: linear-gradient(
    174deg,
    rgba(255, 189, 126, 1) 0%,
    rgba(243, 115, 56, 1) 100%
  );
}

.payment-taken-card {
  background-color: #b71528;
}
</style>
